import React from 'react';
import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useBatchDeleteConceptualLabelDiscoveryMutation } from '../../../../../store/apis/conceptual-label.api';

/**
 * Component for batch deleting selected discovery patterns
 */
const DeleteAllButton = ({ 
    selectedPatternIds, 
    isFormSubmitting, 
    isSaving,
    onDeleteSuccess,
}) => {
    const [batchDeleteConceptualLabelDiscovery, { isLoading: isDeletingBatch }] = useBatchDeleteConceptualLabelDiscoveryMutation();

    const handleDeleteAllSelected = async () => {
        if (selectedPatternIds.length === 0) return;
        
        try {
            await batchDeleteConceptualLabelDiscovery({ 
                patternIds: selectedPatternIds 
            }).unwrap();
            
            // Clear selection after successful delete
            if (onDeleteSuccess) {
                onDeleteSuccess();
            }
        } catch (error) {
            console.error('Error deleting selected patterns:', error);
        }
    };

    if (selectedPatternIds.length === 0) return null

    return (
        <Button 
            danger 
            icon={<DeleteOutlined />}
            loading={isDeletingBatch}
            disabled={isFormSubmitting || isSaving}
            onClick={handleDeleteAllSelected}
        >
            Delete Selected ({selectedPatternIds.length})
        </Button>
    );
};

export default DeleteAllButton; 